import React from 'react';
import { MapPinIcon, EditIcon, TrashIcon } from 'lucide-react';
export const JobLocationsTable = ({
  locations
}) => {
  return <div className="overflow-x-auto" data-id="element-238">
      <table className="w-full" data-id="element-239">
        <thead data-id="element-240">
          <tr className="bg-gray-50 text-xs uppercase" data-id="element-241">
            <th className="px-4 py-3 text-left font-medium text-gray-600" data-id="element-242">
              Job Name
            </th>
            <th className="px-4 py-3 text-left font-medium text-gray-600" data-id="element-243">
              Job Number
            </th>
            <th className="px-4 py-3 text-left font-medium text-gray-600" data-id="element-244">
              Usage Type
            </th>
            <th className="px-4 py-3 text-left font-medium text-gray-600" data-id="element-245">
              Address
            </th>
            <th className="px-4 py-3 text-left font-medium text-gray-600" data-id="element-246">
              Foreman
            </th>
            <th className="px-4 py-3 text-center font-medium text-gray-600" data-id="element-247">
              Actions
            </th>
          </tr>
        </thead>
        <tbody data-id="element-248">
          {locations.map(location => <tr key={location.id} className="border-t hover:bg-gray-50" data-id="element-249">
              <td className="px-4 py-3" data-id="element-250">{location.name}</td>
              <td className="px-4 py-3" data-id="element-251">{location.jobNumber}</td>
              <td className="px-4 py-3" data-id="element-252">
                {location.usageType === 'load-dump' && <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs" data-id="element-253">
                    Load & Dump Site
                  </span>}
                {location.usageType === 'load' && <span className="bg-[#0F2A52]/10 text-[#0F2A52] px-2 py-1 rounded text-xs" data-id="element-254">
                    Load Site
                  </span>}
                {location.usageType === 'dump' && <span className="bg-[#F58220]/10 text-[#F58220] px-2 py-1 rounded text-xs" data-id="element-255">
                    Dump Site
                  </span>}
              </td>
              <td className="px-4 py-3" data-id="element-256">{location.address}</td>
              <td className="px-4 py-3" data-id="element-257">{location.foreman}</td>
              <td className="px-4 py-3" data-id="element-258">
                <div className="flex justify-center gap-2" data-id="element-259">
                  <button className="text-[#0F2A52] hover:text-[#0F2A52]/80 p-1 rounded-full hover:bg-[#0F2A52]/10 transition-colors" data-id="element-260">
                    <MapPinIcon size={18} data-id="element-261" />
                  </button>
                  <button className="text-[#F58220] hover:text-[#F58220]/80 p-1 rounded-full hover:bg-[#F58220]/10 transition-colors" data-id="element-262">
                    <EditIcon size={18} data-id="element-263" />
                  </button>
                  <button className="text-red-500 hover:text-red-700 p-1 rounded-full hover:bg-red-50 transition-colors" data-id="element-264">
                    <TrashIcon size={18} data-id="element-265" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};